import * as C from './card-informative-title.styles'

type CardInformativeTitleProps = {
  children: React.ReactNode
  testID?: string
}

export const CardInformativeTitle = (props: CardInformativeTitleProps) => {
  const { children, testID } = props
  const descriptionProps = {
    numberOfLines: 1,
  }
  return (
    <C.Title {...descriptionProps} testID={testID}>
      {children}
    </C.Title>
  )
}
